
<div class="error-message-container">
    <app-error-message  *ngIf="message!=''" [message]="message"></app-error-message>
</div>
<h2>{{title}}</h2>

<!-- <ng-template> -->
    <div class="verification-code">
        <p *ngIf="!restartcode" style="margin-bottom: 5px;">
            שלחנו לך קוד אימות חד פעמי למספר:
            <span class="phone-number">{{otp}}</span>
        </p>
        <form [formGroup]="verificationCodeForm" id="verificationCodeForm">
            <div class="inputs-button-wrapper">
                <label for="otp" class="eds-input-label">קוד האימות שקיבלת</label>
                <div class='inputs-container'>
                    <div>
                            <input id="otp" autofocus formControlName="verificationCode" type="password" class="input-field" pInputText appOnlynumber togglePassword (input) = "message!='' && resetMassage()"
                            [ngClass]="(isValidFormSubmitted && verificationCode.errors?.required) ? 'inputInvalid' : 'inputNotInvalid'" aria-describedby="verificationInfo">
                        <p-message
                        severity="error"
                        text="שדה חובה"
                        *ngIf="isValidFormSubmitted && verificationCode.errors?.required"
                    ></p-message>
                    </div>
                </div>
                <div id="verificationInfo" class="limited-time">
                    <img src="./assets/images/timer.png" alt="timer">
                    <span>קוד האימות מוגבל בזמן</span>
                </div>
                <div>
                    <div class="container-button-login container-fluid">
                        <p-button type="submit"
                            label="כניסה" (onClick)="CaptchaNeeded ? captchaRef.execute() : checkVerificationCode()">
                        </p-button>
                    </div>
                </div> 
                <div class="container-link">
                <button class="back-button" (click) ="back()">חזרה</button> </div>
            </div>
            <re-captcha #captchaRef="reCaptcha" (resolved)="$event && checkVerificationCode($event)" siteKey="{{this.sitekey}}" size="invisible" ></re-captcha> 
        </form>
    </div>
    <app-loader *ngIf="loader"  [text]="'המערכת בודקת את הנתונים'"></app-loader>
